export default __webpack_public_path__ + "490c7e63db692c7626adaa8454aad4d9.png";